<template>
    <div>
        <div class="pac-card" id="pac-card">
            <div id="pac-container">
                <input
                    id="pac-input"
                    type="text"
                    placeholder="Search for a location here"
                />
            </div>
        </div>
        <div id="map" class="map-placeholder"></div>
    </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import { Constants } from './../../constants.js'
export default {
    name: 'stc-google-map',

    props: {
        defaultLatLng: {
            default: () => {
                return { lat: 59.3274533, lng: 18.0521569 }
            },
            type: Object,
        },
        latLngStr: {
            default: () => {
                return Constants.DefaultGeoCoordinates
            },
            type: String,
        },
    },

    data() {
        return {
            marker: false,
            map: false,
        }
    },

    watch: {
        latLngStr() {
            let value = this.getLatLngFromStr(this.latLngStr)
            if (this.marker) {
                this.marker.setMap(null)
            }
            const map = this.map
            this.marker = new google.maps.Marker({
                position: value,
                map,
                draggable: true,
            })
            this.marker.addListener('dragend', (event) => {
                this.$emit(
                    'updatedLatLngStr',
                    this.marker.position.lat() +
                        ',' +
                        this.marker.position.lng()
                )
            })
            var newOptions = { zoom: 13, center: value }
            map.setOptions(newOptions)
        },
    },

    async created() {
        const coordinates = this.getLatLngFromStr(this.latLngStr)
        const loader = new Loader({
            apiKey: 'AIzaSyBOzzWGhVqo63VjpZsftwwbF6RWb1cXHpM',
            version: 'weekly',
            libraries: ['places'],
        })

        const mapOptions = {
            center: coordinates,
            zoom: 13,
        }

        loader
            .load()
            .then(() => {
                this.map = new google.maps.Map(
                    document.getElementById('map'),
                    mapOptions
                )
                const map = this.map
                this.marker = new google.maps.Marker({
                    position: coordinates,
                    map,
                    draggable: true,
                })

                this.marker.addListener('dragend', (event) => {
                    this.$emit(
                        'updatedLatLngStr',
                        this.marker.position.lat() +
                            ',' +
                            this.marker.position.lng()
                    )
                })

                const input = document.getElementById('pac-input')
                const autocomplete = new google.maps.places.Autocomplete(input)
                autocomplete.bindTo('bounds', map)
                autocomplete.setFields([
                    'address_components',
                    'geometry',
                    'icon',
                    'name',
                    'plus_code',
                ])

                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace()
                    if (!place.geometry) {
                        console.error(
                            "No details available for input: '" +
                                place.name +
                                "'"
                        )
                        return
                    }
                    if (
                        place &&
                        place.plus_code &&
                        place.plus_code.global_code
                    ) {
                        this.$emit(
                            'updatedPlusCode',
                            place.plus_code.global_code
                        )
                    }

                    this.marker.setVisible(false)
                    if (place.geometry.viewport) {
                        map.fitBounds(place.geometry.viewport)
                    } else {
                        map.setCenter(place.geometry.location)
                        map.setZoom(13)
                    }
                    this.marker.setPosition(place.geometry.location)
                    this.marker.setVisible(true)
                    this.$emit(
                        'updatedLatLngStr',
                        this.marker.position.lat() +
                            ',' +
                            this.marker.position.lng()
                    )
                })
            })
            .catch((e) => {
                console.error(`Unable to load google maps. Error: ${e}`)
            })
    },
    methods: {
        getLatLngFromStr(latLngStr) {
            let value = this.defaultLatLng
            if (latLngStr && latLngStr.includes(',')) {
                const latLang = latLngStr.split(',')
                value = {
                    lat: parseFloat(latLang[0]),
                    lng: parseFloat(latLang[1]),
                }
            }
            return value
        },
    },
}
</script>
<style scoped>
.map-placeholder {
    width: 100%;
    height: 100%;
}
.pac-card {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
}

#pac-container {
    padding: 10px;
    background: #394253;
}

.pac-controls {
    display: inline-block;
    padding: 5px 11px;
}

.pac-controls label {
    font-family: Roboto;
    font-size: 13px;
    font-weight: 300;
}

#pac-input {
    background-color: #394253;
    color: #f9fafb;
    font-size: 14px;
    font-weight: 300;
    margin-left: 12px;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;
    font-family: inherit;
}

#pac-input:focus {
    border-color: #4d90fe;
}
</style>